import React from "react";
import Typography from "@mui/material/Typography";

export default function ChoiceView() {
  return (
    <Typography
      align="center"
      mt={2}
      mb={4}
      fontSize={18}
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={280}
    >
      Before adding inventory to this location, let us know if the item already exists in the system or if you need to create a new one.
    </Typography>
  );
}
